import { render, staticRenderFns } from "./countryDetails.vue?vue&type=template&id=6c8af765&scoped=true&"
import script from "./countryDetails.vue?vue&type=script&lang=js&"
export * from "./countryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8af765",
  null
  
)

export default component.exports